import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  #submitHandler = null;
  #cartForm = null;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.#setupCartFormListener();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.#removeCartFormListener();
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  #setupCartFormListener() {
    if (!this.#cartForm) {
      this.#cartForm = this.querySelector('form#cart-form');
    }

    const proceedWithNewCheckout = this.dataset.proceedWithNewCheckout === 'true';

    if (this.#cartForm && proceedWithNewCheckout) {
      this.#submitHandler = (event) => {
        console.log('submitHandler');
        event.preventDefault();
        window.location.href = '/pages/order-checkout';
      };
      this.#cartForm.addEventListener('submit', this.#submitHandler);
    }
  }

  #removeCartFormListener() {
    if (this.#submitHandler) {
      this.#cartForm?.removeEventListener('submit', this.#submitHandler);
      this.#submitHandler = null;
    }
  }

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}